module.exports = __webpack_public_path__ + "img/icon2.4ed74e2d.svg";